import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { FlagsPage } from '@/features/insights/flags-page';

const searchSchema = z.object({
  status: z.enum(['open', 'dismissed', 'resolved']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/insights/flags')({
  validateSearch: searchSchema,
  component: FlagsRoute,
});

function FlagsRoute() {
  const { projectId } = Route.useParams();
  const { status } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <FlagsPage
      projectId={projectId}
      filter={status ?? 'open'}
      onFilter={(next) =>
        void navigate({ search: { status: next === 'open' ? undefined : next }, replace: true })
      }
    />
  );
}
